var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "商品审核",
            visible: _vm.dialogVisible,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", [
            _c(
              "div",
              [
                _c("span", { staticStyle: { width: "90px" } }, [
                  _vm._v("审核状态："),
                ]),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "请选择审核状态" },
                    model: {
                      value: _vm.auditStatus,
                      callback: function ($$v) {
                        _vm.auditStatus = $$v
                      },
                      expression: "auditStatus",
                    },
                  },
                  _vm._l(_vm.options, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-top": "20px" } },
              [
                _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                  _c("span", [_vm._v("审核备注：")]),
                ]),
                _vm._v(" "),
                _c("Tinymce", {
                  attrs: { height: 300 },
                  model: {
                    value: _vm.auditText,
                    callback: function ($$v) {
                      _vm.auditText = $$v
                    },
                    expression: "auditText",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loadingBtn },
                  on: { click: _vm.auditEdit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }